<template>
  <v-app id="inspire">
    <v-navigation-drawer v-model="drawer" fixed app class="grey lighten-4">
      <div class="ma-2">
        <v-card class="mb-2">
          <v-card-text class="pa-1">
            <v-list class="pa-0">
              <v-list-tile avatar>
                <v-list-tile-avatar>
                  <v-btn icon class="hidden-xs-only" to="/">
                    <v-icon>arrow_back</v-icon>
                  </v-btn>
                </v-list-tile-avatar>
                <v-list-tile-content>
                  <v-list-tile-title
                    >Total length:
                    <span class="font-weight-bold">{{
                      formatArea(totalLength)
                    }}</span></v-list-tile-title
                  >
                </v-list-tile-content>
              </v-list-tile>
            </v-list>
          </v-card-text>
        </v-card>
        <v-card>
          <v-card-text>
            <div class="mb-2">
              Start Coordinate: <strong>{{ startCoord }}</strong>
            </div>
            <div>
              End Coordinate: <strong>{{ endCoord }}</strong>
            </div>
          </v-card-text>
          <v-card-text>
            <v-form ref="form" v-model="valid" lazy-validation>
              <v-layout row wrap align-center>
                <v-flex xs6 sm4>
                  <v-subheader>Rows</v-subheader>
                </v-flex>
                <v-flex xs6 sm8>
                  <v-select
                    v-model="rowCount"
                    :items="count"
                    label="Select..."
                    @change="selectRow()"
                    :rules="rowsRules"
                    required
                  ></v-select>
                </v-flex>
              </v-layout>
              <v-divider class="mb-3"></v-divider>
              <v-layout
                v-for="(row, index) in rows"
                :key="index"
                row
                wrap
                align-center
              >
                <v-flex xs6 sm4 class="py-0">
                  <v-subheader>{{ row.name }}</v-subheader>
                </v-flex>
                <v-flex xs6 sm8 class="py-0">
                  <v-select
                    v-model="row.specie"
                    :items="species"
                    label="Species..."
                    return-object
                    text-value="value"
                    item-text="label"
                    :rules="rowRules"
                    @change="changeSpecie(row)"
                    required
                  ></v-select>
                </v-flex>
              </v-layout>
            </v-form>
          </v-card-text>
          <v-card-actions class="pa-3">
            <v-spacer />
            <v-btn color="green darken-2" round outline dark @click="calc()"
              >Calculate</v-btn
            >
          </v-card-actions>
        </v-card>
      </div>
    </v-navigation-drawer>
    <v-content>
      <v-container grid-list-xl v-if="isVisible">
        <v-layout wrap>
          <v-flex xs12>
            <v-card class="elevation-1 mt-3">
              <v-card-text>
                <v-layout wrap>
                  <v-flex xs12 sm8 v-if="information != null">
                    <div class="font-weight-bold">Design:</div>
                    <v-layout pa-2>
                      <v-flex d-flex xs6 shrink>
                        <base-info
                          :item="information.planText"
                          color="green"
                        ></base-info>
                      </v-flex>
                      <v-flex d-flex v-if="information.totAreaAcre">
                        <base-info color="green">
                          <template scop="body">
                            <b>Total Area Acre: </b>
                            {{ information.totAreaAcre }} <br />
                            <b>Total Area: </b> {{ information.totalArea }}
                          </template>
                        </base-info>
                      </v-flex>
                    </v-layout>
                  </v-flex>
                  <v-flex xs12 sm4 v-if="highValue != null">
                    <div class="font-weight-bold">Suitability:</div>
                    <v-layout pa-2>
                      <v-flex xs12>
                        <base-info :item="highValue" color="cyan"></base-info>
                      </v-flex>
                    </v-layout>
                  </v-flex>
                </v-layout>
              </v-card-text>
            </v-card>
          </v-flex>
        </v-layout>
        <v-layout wrap>
          <v-flex v-for="(item, index) in items" :key="index" xs4>
            <base-card :item="item" />
          </v-flex>
        </v-layout>
        <v-layout wrap>
          <v-flex xs12>
            <v-card class="elevation-1">
              <v-card-text v-if="loadingGrowth">
                <v-progress-linear
                  color="green darken-2"
                  :indeterminate="true"
                ></v-progress-linear>
              </v-card-text>

              <v-tabs
                centered
                color="green darken-2"
                dark
                slider-color="yellow"
              >
                <v-tab
                  v-for="(row, index) in rows"
                  :key="index"
                  :href="`#tab-${index}`"
                  @click="changeChart(row)"
                >
                  {{ row.label }}
                </v-tab>
              </v-tabs>
              <v-card-text>
                <div v-if="charts !== null">
                  <vue-highcharts
                    :options="charts"
                    ref="lineCharts"
                    style="width: 100%; height: 300px"
                  ></vue-highcharts>
                </div>
                <div v-else style="height: 300px">
                  <v-alert type="warning" :value="true"
                    >Empty response from server</v-alert
                  >
                </div>
              </v-card-text>
            </v-card>
          </v-flex>
        </v-layout>
      </v-container>
    </v-content>

    <v-dialog v-model="loading" persistent width="300">
      <v-card color="green darken-2" dark>
        <v-card-text>
          Please stand by
          <v-progress-linear
            indeterminate
            color="white"
            class="mb-0"
          ></v-progress-linear>
        </v-card-text>
      </v-card>
    </v-dialog>
  </v-app>
</template>

<script>
import axios from "axios";
import generic from "../mixins/generic";
var async = require("async");
import VueHighcharts from "@/components/vueHighcharts.vue";
import Highcharts from "highcharts";
import highchartsMore from "highcharts/highcharts-more";
highchartsMore(Highcharts);
import _ from "lodash";

export default {
  name: "Row",
  components: {
    VueHighcharts
  },
  mixins: [generic],
  data() {
    return {
      totalLength: this.$route.params.total,
      startCoord: this.$route.params.start,
      endCoord: this.$route.params.end,
      drawer: null,
      valid: true,
      rowRules: [v => !!v || "Row is required"],
      rowsRules: [v => !!v || "Rows is required"],
      count: [1, 2, 3, 4, 5, 6, 7, 8, 9, 10],
      species: [
        { label: "Caragana Spacing", value: "CA" },
        { label: "White Spruce Spacing", value: "WS" },
        { label: "Scots Pine Spacing", value: "SP" },
        { label: "Green Ash", value: "GA" },
        { label: "Hybrid Poplar", value: "HP" },
        { label: "Manitoba Maple", value: "MM" }
      ],
      rowCount: null,
      rows: [],
      hidden: false,
      items: [],
      highValue: null,
      information: null,
      loading: false,
      loadingGrowth: false,
      isVisible: false,
      growthYearArray: [],
      growthArray2: [],
      growthArray3: [],
      growths: [],
      charts: null
    };
  },
  computed: {
    growth: function() {
      let areaData = this.growthArray2;
      let areaData2 = this.growthArray3;
      let categories = [];

      categories = this.growthYearArray;

      var option = {
        chart: {
          backgroundColor: null,
          type: "line"
        },
        title: {
          text: "Future Growth"
        },
        credits: {
          enabled: false
        },
        colors: ["#00bcd4", "#388e3c"],
        xAxis: {
          title: {
            text: null
          },
          crosshair: true,
          categories: categories
        },
        yAxis: {
          title: {
            text: null
          }
        },
        plotOptions: {
          line: {
            fillOpacity: 0.4
          }
        },
        series: [
          {
            name: "RCP4.5",
            data: areaData
          },
          {
            name: "RCP8.5",
            data: areaData2
          }
        ]
      };

      return option;
    }
  },
  methods: {
    changeChart(item) {
      let yearArray = [];
      let arraySeries2 = [];
      let arraySeries3 = [];

      switch (item.label) {
        case "Caragana Spacing":
          yearArray = [];
          arraySeries2 = [];
          arraySeries3 = [];
          break;
        case "White Spruce Spacing":
          yearArray = this.growths.whiteSpruceGrowthArray[0];
          arraySeries2 = this.growths.whiteSpruceGrowthArray[1];
          arraySeries3 = this.growths.whiteSpruceGrowthArray[2];
          break;
        case "Scots Pine Spacing":
          yearArray = [];
          arraySeries2 = [];
          arraySeries3 = [];
          break;
        case "Green Ash":
          yearArray = [];
          arraySeries2 = [];
          arraySeries3 = [];
          break;
        case "Hynbrid Poplar":
          yearArray = [];
          arraySeries2 = [];
          arraySeries3 = [];
          break;
        case "Manitoba Maple":
          yearArray = [];
          arraySeries2 = [];
          arraySeries3 = [];
          break;
      }
      if (
        yearArray.length == 0 ||
        arraySeries2.length == 0 ||
        arraySeries3.length == 0
      ) {
        this.charts = null;
      } else {
        this.growthYearArray = _.dropRight(yearArray);
        this.growthArray2 = _.dropRight(arraySeries2);
        this.growthArray3 = _.dropRight(arraySeries3);
        this.charts = this.growth;
      }
    },
    selectRow() {
      this.rows = [];

      for (var i = 1; i <= this.rowCount; i++) {
        var obj = {};
        obj.name = "Row " + i;
        obj.index = i;
        obj.specie = null;
        obj.value = null;
        obj.label = null;
        obj.suitability = null;
        obj.minumumText = null;
        obj.totalSpaceList = null;
        this.rows.push(obj);
      }
    },
    changeSpecie(item) {
      item.value = item.specie.value;
      item.label = item.specie.label;
    },
    getGrowthSerive() {
      let vm = this;
      vm.loading = true;
      let url = `${process.env.API_ROOT}/futuregrowth/${vm.endCoord}/${vm.startCoord}`;
      let body = [];

      vm.rows.forEach(function(item) {
        var obj = {
          index: item.index,
          value: item.value
        };
        body.push(obj);
      });

      axios
        .post(url, body)
        .then(response => {
          let data = response.data;
          vm.growths = data;
          vm.loading = false;
          vm.changeChart(vm.rows[0]);
        })
        .catch(err => {
          vm.loading = false;
        });
    },
    calc() {
      var vm = this;

      if (vm.$refs.form.validate()) {
        vm.getGrowthSerive();

        vm.items = [];
        let body = [];

        let url = `${process.env.API_ROOT}/designs/${this.totalLength}`;
        let urlSUI = `${process.env.API_ROOT}/suitability/${this.startCoord}/${this.endCoord}`;
        vm.hidden = true;

        if (vm.rows.length > 0) {
          vm.loading = true;
          vm.isVisible = false;
          async.parallel(
            [
              function(callback) {
                axios.post(urlSUI, vm.rows).then(response => {
                  let data = response.data;
                  vm.highValue = data.highValue;

                  vm.rows.forEach(function(row, index) {
                    row.suitability = null;

                    data.resultList.forEach(function(list) {
                      if (list.index == index) {
                        row.suitability = list.minumumText;
                      }
                    });
                  });
                  callback(null, response.data);
                });
              },
              function(callback) {
                axios.post(url, vm.rows).then(response => {
                  let data = response.data;
                  vm.information = data;

                  vm.rows.forEach(function(row, index) {
                    row.minumumText = null;

                    data.minimumToList.forEach(function(list) {
                      if (list.index == index) {
                        row.minumumText = list.minumumText;
                      }
                    });
                    data.totalSpaceList.forEach(function(list) {
                      if (list.index == index) {
                        row.totalSpaceList = list.value;
                      }
                    });
                    vm.items.push(row);
                  });
                  callback(null, response.data);
                });
              }
            ],
            function(err, results) {
              if (err) {
                console.log(err);
              }
              vm.isVisible = true;
            }
          );
        }
      }
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/views/row.vue